import { useState, useContext, useEffect } from 'react'
import { Box, Button, Divider, IconButton, Modal,Paper, Stack, Typography } from '@mui/material'
import CloseIcon from "@mui/icons-material/Close";
import { PinInput } from 'react-input-pin-code';

import { useValidPassword } from '../../hooks/auth/useAuthHooks'
import { Password } from '../../components/auth/authComponents'
import AuthError from './authError';
import { AuthContext } from '../../contexts/auth/authContext'
import { DataContext } from '../../contexts/data/dataContext'
import custom from '../../styles/mui/szVariables.json'
import { analyticsCta, analyticsDomain, analyticsPage } from '../../services/constants'
import { sendClickAnalytics, sendViewAnalytics } from '../common/util/util'

export default function ChangePasswordPopup({ open, setOpen, newForm }: any) {
  const border = custom.border
  const auth = useContext(AuthContext)
  const data = useContext(DataContext)
  const { password, setPassword, passwordIsValid } = useValidPassword('')
  const [ codes, setCodes ] = useState(['', '', '','', '', '']);
  const [ error, setError ] = useState('')
  const [ valid, setValid ] = useState(false)
 
  const {
    password: passwordConfirm,
    setPassword: setPasswordConfirm,
    passwordIsValid: passwordConfirmIsValid,
  } = useValidPassword('')

  const hasCodes = codes.every(c=>c)

  const isNotValid =
    !valid ||
    password.length === 0 ||
    passwordConfirm.length === 0 


  const handleClose = () => {
    setOpen(false);
    auth?.setOtp({})
    setPassword('')
    setPasswordConfirm('')
    setCodes(['', '', '','', '', ''])
    setError('')
  }

  const handlePinInput = (
    value: string | string[], 
    index: number, 
    values: string[]
    ) => {
      setCodes(values)
  }

  
  const changePasswordClicked = async () => {
    try {
      if(password !== passwordConfirm) {
        setError('Password mismatch')
      } else {
        setError('')
        const code = codes.join('');
        await auth.changeUserPassword(password, code)
        handleClose();
        sendClickAnalytics('/profile',{
            domain: analyticsDomain.profile,
            name: analyticsCta.changePassword,
            metadata: {},
          })
      }
    } catch (err: any) {
      sendClickAnalytics('/profile', {
          domain: analyticsDomain.profile,
          name: analyticsCta.changePasswordError,
          metadata: { message: err.message },
        })
      setError(err.message)
    }
  }

  const requestCode = async () => {
    try {
      sendClickAnalytics('/profile',{
          domain: analyticsDomain.profile,
          name: analyticsCta.emailValidationReceiveCode,
          metadata: {},
        })
      await auth.requestCode(data?.customer?.email, 'emailVerification');
    } catch (err: any) {
      setError(err.message)
    }
  }

  function handleEnterKey(ev: any) {
    if(ev.key === "Enter" && 
        !isNotValid && 
        hasCodes)  {
      changePasswordClicked()
    }
  }

  useEffect(()=>{
    sendViewAnalytics('/profile', {
        domain: analyticsDomain.profile,
        name: analyticsPage.changePassword
      })
  },[])

  return (
    <Modal
        open={open}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ 
          display:'flex', 
          alignItems:'center',
          justifyContent:'center'
        }}
      >
      <Paper elevation={0} 
              sx={{ 
                borderRadius: custom.corners5, 
                border: custom.border, 
                width: { 
                    xs:'300px', 
                    sm:'400px', 
                    md:'400px', 
                    lg:'400px'
                  } 
              }}>
        <Box p={custom.spacing.sm} maxWidth="100%">
          <Stack alignItems="center" direction="row" >
              <Typography id="modal-title"  
                variant="szHeading.Bold.Small" >
                  Change Password
              </Typography>
              <IconButton id="closeChangePasswordPopup" 
                    onClick={handleClose} 
                    sx={{ 
                      ml: 'auto',
                      p: custom.spacing.xxxs
                    }}>
                  <CloseIcon sx={{ 
                      border, 
                      borderRadius: custom.corners2, 
                      background: '#FFF' 
                    }} />
              </IconButton>
          </Stack>
        </Box>
        <Divider />
        <Box width="90%" pl={custom.spacing.md}>
            <AuthError error={error} />
        </Box>
        
        {!auth?.otp?.codeVerifier ? 
        <>
          <Box p={custom.spacing.md} maxWidth="100%">
            <Typography variant="szBody.Regular.Medium">
              We will send a verification code to your email, 
              that can help us confirm your identity and secure your account.
            </Typography>
          </Box>
          <Box p={custom.spacing.md}  maxWidth="100%">
            <Button sx={{ p: custom.spacing.sm }} 
              id="changePasswordRequestCode"  
              color="primary" 
              fullWidth
              variant="contained" 
              onClick={requestCode}>
              <Typography color="#FFF"
                variant='szBody.Regular.Medium'>  
                Send code 
              </Typography>
            </Button>
          </Box>
        </> 
        :
        <>
          <Box maxWidth="100%" p={custom.spacing.md}>
              <Typography id="enterCode"
                variant="szHeading.Bold.xxSmall" >
                  Enter code
              </Typography>
              <PinInput
                size='md'
                id="codeInput"
                autoFocus={true}
                values={codes}
                onChange={handlePinInput}
                // onComplete={}
                placeholder=''
              />
          </Box>
          <Box maxWidth="100%" 
                px={custom.spacing.md}
                py={custom.spacing.xxs}>
            <Password label="New Password" 
              passwordIsValid={passwordIsValid} 
              setPassword={setPassword} 
              validation={setValid} 
              newForm={newForm}
              disabled={!hasCodes}
              onKeyUp={handleEnterKey}
              />
          </Box>
          <Box maxWidth="100%" 
                px={custom.spacing.md}
                py={custom.spacing.xxs}>
            <Password label="Confirm Password" 
              confirmPass={password !== passwordConfirm && passwordConfirm.length>0}
              passwordIsValid={passwordConfirmIsValid} 
              setPassword={setPasswordConfirm}
              newForm={newForm}
              disabled={!hasCodes} 
              onKeyUp={handleEnterKey}
              />
          </Box>
          <Box maxWidth="100%" 
                p={custom.spacing.md}>
              <Button sx={{ p: custom.spacing.sm }} 
                id="changePassword"
                fullWidth  
                disabled={isNotValid || !hasCodes} 
                color="primary" 
                variant="contained" 
                onKeyUp={handleEnterKey}
                onClick={changePasswordClicked}>
                Change password
              </Button>
          </Box>
        </>
        }
      </Paper>
    </Modal>
  )
}

